import { __decorate, __metadata } from "tslib";
import { Expose } from 'class-transformer';
import { ArrayNotEmpty, IsArray, IsEnum, IsNotEmpty, IsString } from 'class-validator';
import { IsUndefinable, StringToArray } from '@goparrot/common';
import { LogicalOperatorEnum, PromotionDiscountBehaviourEnum, PromotionDiscountLevelEnum, PromotionTypeEnum } from '../../common';
import { PromotionGroupLevelEnum } from '../interface';
export class PromotionFilterDto {
    constructor() {
        this.discountBehaviourLogicalOperator = LogicalOperatorEnum.AND;
        this.tagLogicalOperator = LogicalOperatorEnum.AND;
        this.type = [PromotionTypeEnum.PROMOTION];
    }
}
__decorate([
    Expose(),
    StringToArray({ separator: '|' }),
    IsUndefinable({ always: true }),
    IsArray({ always: true }),
    IsEnum(PromotionDiscountLevelEnum, { always: true, each: true }),
    __metadata("design:type", Array)
], PromotionFilterDto.prototype, "discountLevel", void 0);
__decorate([
    Expose(),
    StringToArray({ separator: '|' }),
    IsUndefinable({ always: true }),
    IsArray({ always: true }),
    IsEnum(PromotionGroupLevelEnum, { always: true, each: true }),
    __metadata("design:type", Array)
], PromotionFilterDto.prototype, "groupLevel", void 0);
__decorate([
    Expose(),
    StringToArray({ separator: '|' }),
    IsUndefinable({ always: true }),
    IsArray({ always: true }),
    IsString({ always: true, each: true }),
    ArrayNotEmpty({ always: true }),
    __metadata("design:type", Array)
], PromotionFilterDto.prototype, "whitelist", void 0);
__decorate([
    Expose(),
    StringToArray({ separator: '|' }),
    IsUndefinable({ always: true }),
    IsArray({ always: true }),
    IsEnum(PromotionDiscountBehaviourEnum, { always: true, each: true }),
    __metadata("design:type", Array)
], PromotionFilterDto.prototype, "discountBehaviour", void 0);
__decorate([
    Expose(),
    IsUndefinable({ always: true }),
    IsEnum(LogicalOperatorEnum, { always: true }),
    __metadata("design:type", String)
], PromotionFilterDto.prototype, "discountBehaviourLogicalOperator", void 0);
__decorate([
    Expose(),
    StringToArray({ separator: '|' }),
    IsUndefinable({ always: true }),
    IsArray({ always: true }),
    IsString({ always: true, each: true }),
    __metadata("design:type", Array)
], PromotionFilterDto.prototype, "tag", void 0);
__decorate([
    Expose(),
    IsUndefinable({ always: true }),
    IsEnum(LogicalOperatorEnum, { always: true }),
    __metadata("design:type", String)
], PromotionFilterDto.prototype, "tagLogicalOperator", void 0);
__decorate([
    Expose(),
    StringToArray({ separator: '|' }),
    IsUndefinable({ always: true }),
    IsArray({ always: true }),
    IsString({ always: true, each: true }),
    IsNotEmpty({ always: true, each: true }),
    __metadata("design:type", Array)
], PromotionFilterDto.prototype, "discountTargetUuid", void 0);
__decorate([
    Expose(),
    StringToArray({ separator: '|' }),
    IsUndefinable({ always: true }),
    IsArray({ always: true }),
    IsEnum(PromotionTypeEnum, { always: true, each: true }),
    __metadata("design:type", Array)
], PromotionFilterDto.prototype, "type", void 0);
__decorate([
    Expose(),
    IsUndefinable({ always: true }),
    IsString({ always: true }),
    __metadata("design:type", String)
], PromotionFilterDto.prototype, "storeId", void 0);
//# sourceMappingURL=PromotionFilterDto.js.map